import React, { Component } from 'react'
import { connect } from 'react-redux'
import {getFormattedTime, docStatusToString} from '../../../util/displayUtils.js';
import { Link } from 'react-router-dom'

import { getEditorPrice } from '../../../actions/editordashboard.js'

class EditorDocumentsTable extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        var docs = this.props.documents.map(function(doc, i){
            return(
              <tr key={i}>
                <td>{Math.ceil(doc.word_count / 325)}</td>
                <td>{getFormattedTime(doc.due_date)}</td>
                <td>${getEditorPrice(doc)}</td>
                <td><Link to={"/admindashboard/document/" + doc.doc_id}>{doc.doc_name}</Link></td>
                <td>{docStatusToString(doc.doc_status)}</td>
                <td>{doc.word_count}</td>
                <td>{doc.time_limit}</td>                
              </tr>
            )
          });
        return (
            <table className="dashboard-paperlist">
            <tbody>
              <tr>
                <th>Pages</th>
                <th>Due Date</th>
                <th>Pay</th>
                <th>Document Name</th>
                <th>Status</th>
                <th>Word Count</th>
                <th>Time Limit</th>
                {/* TBD add rating column? */}
              </tr>
              {docs}
            </tbody>
          </table>
        )
    }
}
export default connect( ({EditorDocumentsTable}) => ({EditorDocumentsTable}) ) (EditorDocumentsTable)



// WEBPACK FOOTER //
// ./src/components/dashboards/AdminDashboard/EditorDocumentsTable.js